(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@sm360/widget-commons-general"), require("@sm360/widget-commons-core-services"));
	else if(typeof define === 'function' && define.amd)
		define("commons-leads", ["@sm360/widget-commons-general", "@sm360/widget-commons-core-services"], factory);
	else if(typeof exports === 'object')
		exports["commons-leads"] = factory(require("@sm360/widget-commons-general"), require("@sm360/widget-commons-core-services"));
	else
		root["CommonsLeads"] = factory(root["CommonsGeneral"], root["CommonsCoreServices"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__) {
return 